import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";

export const LoadingPage = () => {
  return (
    <Box>
      <PrimarySearchAppBar />
      <Box>
	You need to log in to see contents!
      </Box>
    </Box>
  );
};